import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Checkbox } from '@wds/checkbox';
import { Menu } from '@wds/menu';
import { Typography } from '@wds/typography';
import { IconCaretDown } from '@wds/icons';
import { ALL_FILTER_ID, BACKGROUND_COLOR_HOVER, BLUE_CHECK, BORDER_COLOR, BORDER_COLOR_HOVER } from '../../../constants';
export const COPY = {
  iconCaretDown: {
    id: 'OpenEndedCoding.MultiSelect.iconCaretDown',
    defaultMessage: 'Caret down icon',
    description: '[Type: Label][Vis: low] - Caret down icon'
  }
};
const useStyles = createUseStyles(theme => ({
  trigger: {
    '& > button': {
      borderColor: BORDER_COLOR,
      padding: `0 ${theme.spacing[3]}px`,
      '&:hover, &:focus': {
        backgroundColor: BACKGROUND_COLOR_HOVER,
        borderColor: BORDER_COLOR_HOVER,
        outline: 0,
        boxShadow: '0px 2px 4px 0px rgb(0 0 0 / 14%)',
        transition: 'border-color 100ms ease 0s'
      }
    }
  },
  menu: {
    // style the checkbox blue
    '& input[class^="wrenchCheckboxNative"]:checked + span[class^="wrenchCheckboxFaux"]': {
      background: BLUE_CHECK,
      borderColor: BLUE_CHECK
    },
    '& input[class^="wrenchCheckboxNative"]:focus:checked + span[class^="wrenchCheckboxFaux"]': {
      borderColor: `${BLUE_CHECK} !important`,
      boxShadow: 'none !important'
    }
  }
}));
const MultiSelect = ({
  title,
  values,
  label,
  disabled = false,
  handleSelect
}) => {
  const classes = useStyles();
  const wrapperRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  // handle clicks outside menu
  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  const allOption = values.find(v => v.id === ALL_FILTER_ID);
  const shouldDisableAllOption = id => {
    if (!allOption || allOption.id === id) {
      return false;
    }
    return allOption.selected;
  };
  const trigger = _jsx(Box, {
    className: classes.trigger,
    children: _jsxs(Button, {
      color: "secondary",
      variant: "ghost",
      size: "md",
      disabled: disabled,
      children: [_jsx(Typography, {
        color: "dark",
        children: title
      }), _jsx(IconCaretDown, {
        title: t(COPY.iconCaretDown),
        color: "dark"
      })]
    })
  });
  return _jsxs("div", {
    ref: wrapperRef,
    className: classes.menu,
    children: [label && _jsx(Box, {
      mb: 2,
      children: _jsx(Typography, {
        component: "strong",
        variant: "bodySm",
        color: "dark",
        children: label
      })
    }), _jsx(Menu, {
      "data-testid": `Menu__${title}`,
      dense: true,
      noRules: true,
      menuTrigger: trigger,
      autoClose: false,
      show: showMenu,
      onChange: show => setShowMenu(show),
      children: values.map(({
        id,
        label: menuLabel,
        selected
      }) => _jsx(Menu.Item, {
        addOn: _jsx(Checkbox, {
          "data-testid": `Checkbox-${id}`,
          id: `checkbox-${id}`,
          checked: selected || shouldDisableAllOption(id),
          value: id,
          disabled: shouldDisableAllOption(id),
          onChange: () => handleSelect(id)
        }),
        addOnPlacement: "left",
        onClick: () => {
          if (!shouldDisableAllOption(id)) {
            handleSelect(id);
          }
        },
        children: menuLabel
      }, `${title}-${id}`))
    })]
  });
};
export default MultiSelect;